import React from "react";

function CloseIcon() {
  return (
      <span className="anticon anticon-block">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
            <g fill="none" fillRule="evenodd">
                  <g fill="#0096dc">
                    <g>
                        <g>
                            <g>
                                <path d="M11 72c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 89.075 0 83s4.925-11 11-11zM2 83c0 4.97 4.03 9 9 9 2.125 0 4.078-.736 5.617-1.968l-12.65-12.65C2.738 78.923 2 80.876 2 83zm9-9c-2.125 0-4.078.736-5.617 1.968l12.65 12.65C19.262 87.077 20 85.124 20 83c0-4.97-4.03-9-9-9z" transform="translate(-910 -203) translate(303 81) translate(589 49) translate(18 1)"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </span>
  );
}

export default CloseIcon;
